import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminLayoutComponent } from './admin-layout/ui-components/admin-layout/admin-layout.component';
import { AuthComponent } from './auth/auth.component';
import { UrlSegmentDelimiter } from './core/constants-repository/app-style.constants';
import { AuthGuard } from './core/guards/auth.guard';
import { ShiveRoutes } from './core/routing/segments/route-segments';
import { InvitationRegistrationComponent } from './public/invitation-registration/invitation-registration.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';

const routes: Routes = [
  {
    path: ShiveRoutes.Auth,
    component: AuthComponent,
    pathMatch: 'full',
  },
  {
    path: ShiveRoutes.Invite + UrlSegmentDelimiter + ShiveRoutes.Accept,
    component: InvitationRegistrationComponent,
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./admin-layout/ui-components/admin-layout/admin-layout.module').then(
        (m) => m.AdminLayoutModule,
      ),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', bindToComponentInputs: true }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
